import { SITE_ORIGIN } from "../seo/metadata";
import CYRILLIC_TO_LATIN_MAP from "./productSlugMap.json";

export function createProductSlug(title) {
  if (!title) {
    return "";
  }

  const normalizedTitle = String(title)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

  if (!normalizedTitle) {
    return "";
  }

  const transliterated = normalizedTitle
    .split("")
    .map((char) => CYRILLIC_TO_LATIN_MAP[char] ?? char)
    .join("");

  return transliterated
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function createProductPath(productId, title) {
  const safeId = productId == null ? "" : String(productId).trim();
  const slug = createProductSlug(title);

  if (!safeId) {
    return "/";
  }

  if (!slug) {
    return `/product/product-${safeId}`;
  }

  return `/product/${slug}-${safeId}`;
}

export function extractProductId(titleId) {
  const rawId = String(titleId || "").split("-").pop();
  const normalizedId = rawId.trim();

  return /^\d+$/.test(normalizedId) ? normalizedId : null;
}

export function createCanonicalProductUrl(productId, title) {
  return `${SITE_ORIGIN}${createProductPath(productId, title)}`;
}
